<template>
  <div class="container">
    <h3>Saison {{ season.title }}</h3>
    <ul>
      <li v-if="season.locationCount">
        {{ season.locationCount | countStr('Location', 'Locations') }}
        <template v-if="season.districtCount">
          in {{ season.districtCount | countStr('Bezirk', 'Bezirken') }}
        </template>
      </li>
      <li v-if="season.productionCount">
        {{ season.productionCount | countStr('Produktion', 'Produktionen') }}
      </li>
    </ul>
    <div class="posters">
      <figure v-for="(poster, index) in season.posters" :key="poster._key">
        <router-link :to="galleryRoute(index)" @click.native.stop="() => {}">
          <ResponsiveImage :image="poster" :ratio="false" />
        </router-link>
      </figure>
    </div>
    <p v-for="claim in season.claims" :key="claim">{{ claim }}</p>
  </div>
</template>

<script>
import ResponsiveImage from '@/components/ResponsiveImage.vue'

export default {
  name: 'SeasonInfo',
  props: ['season'],
  components: { ResponsiveImage },
  methods: {
    galleryRoute(index) {
      const route = this.route(this.season)
      const hash = `#${index + 1}`
      return { ...route, hash }
    }
  }
}
</script>

<style scoped>
h3 {
  @mixin type-jumbo;
  padding-bottom: 0.1em;
}
ul {
  @mixin type-smaller;
}
li + li {
  font-weight: 600;
}
.posters {
  display: flex;
  flex-wrap: wrap;
  padding-top: 0.4em;
  padding-left: var(--content-indent);
  figure {
    margin-right: 4px;
  }
}
/deep/ .posters {
  img {
    height: 80px;
    width: auto;
    width: calc(80px * var(--aspect-ratio, 1));
    object-fit: cover;
  }
}
p {
  @mixin type-larger;
  font-weight: 600;
  padding-top: 0.5em;
}
@media only print {
  .container {
    display: inline-block;
    width: 100%;
    page-break-inside: avoid;
  }
}
</style>
